{
  "title": "Edit Household Member",
  "client": "Client",
  "relationshipTo": "Relationship to {{whom}} (primary member)",
  "continue": "Continue",
  "updated": "Household member {{memberName}} has been updated.",
  "save": "Save",
  "accessType": "Permissions"
}
